// extracted by mini-css-extract-plugin
export default {"root":"qgnWctFjOxAdNbBc7_2p","link":"jX115JXuOypWuuHCRP0a","disabled":"n8KfxI2voVTLdm15LJ0I","placeHolderShimmer":"R5wq6GFFhP9QwhzW1up6"};